import { render, staticRenderFns } from "./SaraSettingsPreview.vue?vue&type=template&id=081f3702&scoped=true&"
import script from "./SaraSettingsPreview.vue?vue&type=script&lang=ts&"
export * from "./SaraSettingsPreview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081f3702",
  null
  
)

export default component.exports